var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForm04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Form-04__Icn/40px/Form-04",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Form-04__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Form-04__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.0810547,7.09082031 L29,10 L23.7333984,18.5454102 L27,30 L12,23.8945312 L15.6640625,18.5454102 L12,12 L17.0810547,7.09082031 Z M17.678,9.295 L14.497,12.367 L18.0155448,18.65159 L15.052,22.978 L23.95,26.599 L21.5683783,18.246359 L25.855,11.29 L17.678,9.295 Z",
    id: ".._.._src_svg_Icn_40px_Form-04__Rectangle-Copy"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForm04);
export default __webpack_public_path__ + "static/media/Form-04.ff5d6bfefb45b9c48bf9b13aaa4dfd23.svg";
export { ForwardRef as ReactComponent };